// Module
var code = "<div class=\"widget-content relative quality-chart-widget\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <div class=\"chart\" id=\"chart\"> </div> </div>";
// Exports
module.exports = code;